<script>
import FormDefault from "../Utils/Page/FormDefault";

export default {
    name: "Form",
    mixins: [FormDefault],
    data() {
        return {
            lang: this.$ml.get('pages.subscription_gift'),
            buttons: [
            ],

            typeForm: {
                user_id: 'select',
                plan_id: 'select',
                parent_id: 'select',
                occasion_id: 'select',
                sender_notify: 'boolean',
                message: 'textarea',
            },

            pageRouteList: 'subscription_gift',
            pageRouteEdit: 'subscription_gift.edit',
            pageApi: 'subscription_gift',
        }
    },
    methods: {
        getSelectLabel(label) {
            if (label === 'user_id' || label === 'parent_id' || label === 'occasion_id') {
                return 'name'
            }
            return 'title'
        },
    }
}
</script>
